<template>
    <v-text-field :label="label + (required ? ' *': '')" @input="$emit('input', $event)" :rules="rules"></v-text-field>
</template>

<script>
    export default {
        name: 'GenericTextField',
        props: {
            label: String,
            required: Boolean
        },
        computed: {
            rules() {
                return [
                    v => !this.required || !!v || this.$t('login.fields.rules.required')
                ]
            }
        }
    };
</script>

<style scoped>

</style>